export default function ComparisonTable() {
  return (
    <div className="comparison-table">
      <p>Comparison table coming soon.</p>
    </div>
  );
}